// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"88":"17c972ca","230":"90339b12","234":"323dc88d","303":"d1b8e56a","810":"a722163f","912":"ab1b625d"}[chunkId] + ".chunk.css";
};